function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes("shopify:section")) {
    if (
      domElement.hasAttribute("data-section-id") &&
      domElement.getAttribute("data-section-id") === event.detail.sectionId
    )
      executeCallback = true;
  } else if (
    event.type.includes("shopify:block") &&
    event.target === domElement
  ) {
    executeCallback = true;
  }
  if (executeCallback) callback(event);
}

// is in viewport
function inViewport(elem, callback, options = {}) {
  return new IntersectionObserver((entries) => {
    entries.forEach((entry) => callback(entry));
  }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function (arg) {
  document.body.classList.toggle(arg);
};
// Get Element Height
function getElementHeight(targetElement, appendTo, cssVar) {
  let element = document.querySelector(targetElement);

  if (element) {
    let elementHeight = element.offsetHeight;
    document
      .querySelector(appendTo)
      .style.setProperty(cssVar, `${elementHeight}px`);
  }
}

// first we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () => {
  const roundedVh = Math.round(window.innerHeight * 0.01);
  document.body.style.setProperty("--vh", `${roundedVh}px`);
};
window.addEventListener("resize", getSetVh);

// Browser check
function getNavigator() {
  const isiOS =
    navigator.userAgent.match(/(iPhone|iPad|iPod)/) &&
    navigator.userAgent.match(/AppleWebKit/) &&
    !navigator.userAgent.match(/CriOS/);
  const isSafari =
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
    Object.prototype.toString.call(window.HTMLElement).indexOf("Constructor") >
      0 ||
    (navigator.userAgent.indexOf("Safari") != -1 &&
      navigator.userAgent.indexOf("Chrome") == -1);
  const isChrome =
    (!!window.chrome &&
      (!!window.chrome.webstore || !!window.chrome.runtime)) ||
    navigator.userAgent.indexOf("Chrome") != -1;
  const isFirefox =
    typeof InstallTrigger !== "undefined" ||
    navigator.userAgent.indexOf("Firefox") != -1;
  const isEdge =
    !!window.StyleMedia || navigator.userAgent.indexOf("Edge") != -1;

  if (isiOS) document.documentElement.classList.add("ios");
  if (isSafari) document.documentElement.classList.add("safari");
  if (isChrome) document.documentElement.classList.add("chrome");
  if (isFirefox) document.documentElement.classList.add("firefox");
  if (isEdge) document.documentElement.classList.add("edge");
}

// Toggle
let toggleClass = function (qSelectors, bodyClass) {
  document
    .querySelectorAll(qSelectors)
    .forEach((e) =>
      e.addEventListener("click", () => toggleBodyClass(bodyClass))
    );
};
// Menu
let toggleMenu = function () {
  toggleClass(".fire-menu, .shrink-menu", "open-menu");
};

function initializeDetailsControls() {
  // Handle dropdown menu
  const detailsElementsLv1 = document.querySelectorAll("details.lv1");
  const detailsElementsClosex = [
    ...document.querySelectorAll("details.closex"),
  ];

  function closeOtherDetails(element) {
    const detailsOpened = document.querySelectorAll("details[open].lv1");
    for (const item of detailsOpened) {
      if (element !== item) {
        item.removeAttribute("open");
      }
    }
  }

  function closeAllDetailsExcept(target) {
    detailsElementsClosex.forEach((f) =>
      !f.contains(target) ? f.removeAttribute("open") : ""
    );
    a11yDetails();
  }

  function closeAllDetails() {
    detailsElementsClosex.forEach((f) => f.removeAttribute("open"));
    a11yDetails();
  }

  // Dropdown menu
  detailsElementsLv1.forEach((item) => {
    item.addEventListener("click", function () {
      closeOtherDetails(this);
    });
  });

  // Close details when clicked outside
  document.addEventListener("click", function (e) {
    if (!detailsElementsClosex.some((f) => f.contains(e.target))) {
      closeAllDetails();
    } else {
      closeAllDetailsExcept(e.target);
    }
  });

  // Close details with esc key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      closeAllDetails();
    }
  });

  // Initial accessibility settings
  a11yDetails();
}

function a11yDetails() {
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute(
      "aria-expanded",
      summary.parentNode.hasAttribute("open")
    );

    if (summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }

    summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });
  });
}

// update button price on variant change
function updatePrice(obj, idd) {
  var uid = obj.options[obj.selectedIndex].getAttribute("data-price");
  var pb = document.querySelector(".uprice" + idd);
  pb.innerHTML = uid;
}

function selectOptions(obj, idd) {
  updatePrice(obj, idd);
}

// Debug
if (window.location.href.includes("debug")) {
  const OpenThinking = {
    theme: { name: "Bullet", version: Shopify.theme.schema_version },
  };
  const tsiCheck =
    Shopify.theme.theme_store_id === null || Shopify.theme.theme_store_id === ""
      ? "❌"
      : "✅";
  console.log(
    `${tsiCheck} ${OpenThinking.theme.name} v${OpenThinking.theme.version} - ${Shopify.shop}`
  );
  alert(
    `${tsiCheck} ${OpenThinking.theme.name} v${OpenThinking.theme.version} `
  );
}

// Bullet marquee
if (!customElements.get("bullet-marquee"))
  customElements.define(
    "bullet-marquee",
    class bulletMarquee extends HTMLElement {
      constructor() {
        super();
        if (window.ResizeObserver)
          new ResizeObserver(this.duration.bind(this)).observe(this);
      }

      duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute("bullet-speed") || 5);
        const contentWidth = entries[0].contentRect.width;

        // Calculate the slowFactor based on content width
        let slowFactor =
          contentWidth <= 375
            ? 1
            : contentWidth >= 1280
            ? 3
            : 1 + (contentWidth - 375) / (1280 - 375);

        // Calculate the scrolling speed with the adjusted slowFactor
        const scrollingDuration = (
          (scrollingSpeed *
            slowFactor *
            entries[0].target.querySelector("span").clientWidth) /
          contentWidth
        ).toFixed(3);

        this.style.setProperty("--bullet-speed", `${scrollingDuration}s`);
      }
    }
  );

function marqueeCellsFunc() {
  const marqueeCells = document.querySelectorAll(".marquee x-cell");
  marqueeCells.forEach((cell) => {
    cell.innerHTML = cell.innerHTML.replace(/(\s{2,})/g, (match) => {
      const nbsp = match.replace(/ /g, "&nbsp;");
      return `<span>${nbsp}</span>`;
    });
  });
}

/* Custom popup*/
function initCustomPopup() {
  var input = document.querySelector("#bannerPhone");
  const errorMap = [
    "Invalid number",
    "Invalid country code",
    "Too short",
    "Too long",
    "Invalid number",
  ];
  let phoneNumber = "";
  const validation = document.querySelector(
    ".discount-banner__step-second #bannerPhone-validation"
  );

  const formEmail = document.querySelector(
    "#mc-embedded-subscribe-form-2 #mce-EMAIL-2"
  );
  const formPhone = document.querySelector(
    "#mc-embedded-subscribe-form-2 #mce-PHONE-2"
  );

  let iti = null;

  if (input && formPhone) {
    iti = window.intlTelInput(input, {
      initialCountry: "auto",
      loadUtils: () =>
        import(
          "https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.0/build/js/utils.js"
        ),
    });

    input.onchange = () => {
      resetValidation(validation);
    };
  }

  const popup = document.querySelector("dialog#discount-banner");

  if (popup) {
    if (!localStorage.getItem("discountBannerShown")) {
      popup.classList.remove("hidden");
    }

    const closeBtns = popup.querySelectorAll(".discount-banner-close");
    if (closeBtns.length) {
      closeBtns.forEach((btn) => {
        btn.onclick = () => {
          closeBanner();
        };
      });
    }

    const firstStepElement = popup.querySelector(
      ".discount-banner__step-first .first"
    );
    if (firstStepElement) {
      firstStepElement.onclick = () => goToSecondStep();
    }

    const secondStepElement = popup.querySelector(
      ".discount-banner__step-second .vip"
    );
    if (secondStepElement && formPhone) {
      secondStepElement.onclick = () => goToThirdStep(formPhone);
    }

    const thirdStepElement = popup.querySelector(
      ".discount-banner__step-third button"
    );
    const emailInput = document.querySelector(
      ".discount-banner__step-third input"
    );
    if (!emailInput) return;

    emailInput.addEventListener("change", (event) => {
      const emailValue = event.target.value.trim();
      if (thirdStepElement) {
        thirdStepElement.onclick = () => goToFourthStep(emailValue);
      }
    });

    const coupon = popup.querySelector(".discount-banner__end p");
    const copied = popup.querySelector(".discount-banner__end small");

    if (coupon && copied) {
      coupon.onclick = () => {
        navigator.clipboard
          .writeText(coupon.innerText)
          .then(() => {
            copied.classList.add("visible");

            setTimeout(() => {
              copied.classList.remove("visible");
            }, 2000);
          })
          .catch((err) => console.error("Помилка копіювання: ", err));
      };
    }
  }

  function closeBanner() {
    document.getElementById("discount-banner").classList.add("hidden");
    localStorage.setItem("discountBannerShown", "true");
  }

  function goToSecondStep() {
    document
      .querySelectorAll(".discount-banner__step")
      ?.forEach((el) => el.classList.add("hidden"));
    document
      .querySelector(".discount-banner__step-second")
      ?.classList.remove("hidden");
  }

  function goToThirdStep(formPhone) {
    const phone = document.querySelector(
      ".discount-banner__step-second #bannerPhone"
    );

    if (phone && validation) {
      if (iti.isValidNumber()) {
        document
          .querySelectorAll(".discount-banner__step")
          ?.forEach((el) => el.classList.add("hidden"));
        document
          .querySelector(".discount-banner__step-third")
          ?.classList.remove("hidden");
        formPhone.value = iti.getNumber();
      } else {
        const errorCode = iti.getValidationError();
        const msg = errorMap[errorCode] ?? "Invalid number";
        validation.innerText = msg;
      }
    }
  }

  function goToFourthStep(emailValue) {
    if (emailValue) {
      document
        .querySelector(".discount-banner__end-wrapper")
        ?.classList.remove("hidden");
      formEmail.value = emailValue;
    }
  }

  function resetValidation(validation) {
    validation.innerText = "";
  }

  function closeDiscountBtn() {
    const btn = document.querySelector("#hide-discount-banner");

    if (btn) {
      btn.style.display = "none";
    }
  }

  function showPopup() {
    document.getElementById("discount-banner")?.classList.remove("hidden");
  }

  const showBannerBtn = document.querySelector("#hide-discount-banner");
  const closeDiscBtn = document.querySelector(
    "#hide-discount-banner #hide-hide-button"
  );

  if (showBannerBtn && closeDiscBtn) {
    showBannerBtn.onclick = () => showPopup();
    closeDiscBtn.onclick = (e) => {
      e.stopPropagation();
      closeDiscountBtn();
      localStorage.setItem("discountBannerShown", "true");
    };
  }
}

function popupFormInit() {
  const form = document.getElementById("mc-embedded-subscribe-form-2");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var form = this;
      var formData = new FormData(form);

      fetch(form.action, {
        method: "POST",
        mode: "no-cors",
        body: formData,
      });
    });
  }
}

function comingSoonTooltipInit() {
  const buttons = document.querySelectorAll(".soon");
  const tooltip = document.getElementById("tooltip");

  function showTooltip(tooltip, button) {
    tooltip.classList.add("active");
    FloatingUIDOM.computePosition(button, tooltip, {
      placement: "top",
      middleware: [
        FloatingUIDOM.offset(8),
        FloatingUIDOM.shift({ padding: 5 }),
      ],
    }).then(({ x, y }) => {
      Object.assign(tooltip.style, {
        left: `${x}px`,
        top: `${y}px`,
      });
    });
  }

  function hideTooltip() {
    tooltip.classList.remove("active");
  }

  if (buttons.length && tooltip) {
    buttons.forEach((button) => {
      button.addEventListener("mouseenter", () => showTooltip(tooltip, button));
      button.addEventListener("mouseleave", () => hideTooltip());
    });
  }
}

function bottomFormInit() {
  if (localStorage.getItem("subscribed") === "true") {
    hideForm();
    showMessage("Thanks for subscribing!");
  }

  const form = document.getElementById("mc-embedded-subscribe-form");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var form = this;
      var formData = new FormData(form);

      fetch(form.action, {
        method: "POST",
        mode: "no-cors",
        body: formData,
      })
        .then(function () {
          localStorage.setItem("subscribed", "true");
          hideForm();
          showMessage("Thanks for subscribing!");
        })
        .catch(function () {
          showMessage("There was an error. Please try again later.");
        });
    });
  }

  function hideForm() {
    var form = document.getElementById("mc-embedded-subscribe-form");
    if (form) {
      form.style.display = "none";
    }
  }

  function showMessage(message) {
    var msg = document.getElementById("response-message");
    if (!msg) {
      msg = document.createElement("p");
      msg.id = "response-message";
      var form = document.getElementById("mc-embedded-subscribe-form");
      form.parentNode.insertBefore(msg, form.nextSibling);
    }
    msg.textContent = message;
  }
}

/*** init app */
function app() {
  getSetVh(); // get Viewport Height
  getNavigator(); // get the browser + OS
  toggleMenu(); // toggle Menu
  initializeDetailsControls(); // call
  bottomFormInit(); //bottom form
  popupFormInit(); // popup form
  comingSoonTooltipInit(); // coming soon tooltip

  window.onload = () => {
    initCustomPopup(); //custom popup
  };
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => {
  app();
});
